import React, { useState, useEffect, useContext } from "react";

import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useHistory } from "react-router-dom";

import api from "../../services/api";
import isEmail from "../../utils/isEmail";
import { notify } from "../../utils/notify";
import MaskService from "../../utils/mask/maskService";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import { UserContext } from "../../context/UserContext";
import SelectCustom from "../../components/basic/SelectCustom";
import { createUser } from "../../repositories/userRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";

const CreateUser = () => {
  const { user } = useContext(UserContext);
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [promoter, setPromoter] = useState(null);
  const [typeUser, setTypeUser] = useState(0);
  const [profile, setProfile] = useState(0);
  const [active, setActive] = useState(true);
  const [optionsPromoters, setOptionsPromoters] = useState([]);
  const [optionsTypeUsers, setOptionsTypeUsers] = useState([]);
  const [optionsProfiles, setOptionsProfiles] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const { data: result } = await api.get(`usuario/dadosParaCriarUsuario`);
        const data = result.data;

        data.typeUsers.unshift({ Id: 0, Nome: "" });
        data.profiles.unshift({ Id: 0, Descricao: "" });

        setOptionsPromoters(data.promoters);
        setOptionsTypeUsers(data.typeUsers);
        setOptionsProfiles(data.profiles);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getData();
  }, [user.IdTipoUsuario]);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      let validationFail = false;

      const resultValidation = validatesNotNull([
        { value: name, key: "name" },
        { value: email, key: "email" },
        { value: telephone, key: "telephone" },
        { value: promoter, key: "promoter" },
        { value: typeUser, key: "typeUser" },
        { value: profile, key: "profile" },
      ]);

      if (email && !isEmail(email)) {
        validationFail = true;
        resultValidation.errorsValidation.email = true;
        notify("O e-mail informado é inválido.", true, "error");
      }

      if (telephone && !MaskService.isValid("cel-phone", telephone)) {
        validationFail = true;
        resultValidation.errorsValidation.telephone = true;
        notify("O telefone informado é inválido.", true, "error");
      }

      if (resultValidation.error || validationFail) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      } else {
        setErrors({});
      }

      const { data } = await createUser({
        body: {
          Nome: name,
          Email: email,
          Telefone: telephone,
          PromotorCNPJ: promoter.CNPJ,
          IdTipoUsuario: typeUser.Id,
          IdPerfilAcesso: profile.Id,
          FlagAtivo: active ? "S" : "N",
        },
      });

      setLoading(false);

      if (data.success) {
        if (!data.warnings) notify("Usuário criado com sucesso.", true, "info");
        goBack();
      }
    } catch (error) {
      console.error("ERROR: CreateUser", error);
      return setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={6}
          md={7}
          sm={7}
          xs={10}
          id="formContent"
        >
          <ArrowBackIcon className="iconGoBack" onClick={goBack} />

          <label className="title">Novo usuário</label>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Nome*"
              autoFocus
              type="text"
              value={name}
              error={errors.name}
              setValue={setName}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="E-mail*"
              type="text"
              value={email}
              error={errors.email}
              setValue={setEmail}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              label="Telefone*"
              type="text"
              value={telephone}
              error={errors.telephone}
              mask="cel-phone"
              setValue={setTelephone}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <SelectCustom
              label="Promotor*"
              keyObject="Fantasia"
              value={promoter}
              setValue={setPromoter}
              error={errors.promoter}
              optionsList={optionsPromoters}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <SelectCustom
              label="Tipo de usuário*"
              keyObject="Nome"
              value={typeUser}
              setValue={setTypeUser}
              error={errors.typeUser}
              optionsList={optionsTypeUsers}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <SelectCustom
              label="Perfil*"
              keyObject="Descricao"
              value={profile}
              setValue={setProfile}
              error={errors.profile}
              optionsList={optionsProfiles}
            />
          </Grid>

          <FormControlLabel
            style={{ color: "#828282" }}
            control={
              <Checkbox
                checked={active}
                onChange={() => setActive(!active)}
                name="checkedB"
                className="checkboxColor"
              />
            }
            label="Usuário Ativo"
          />

          <button
            id="buttonStyle"
            type="submit"
            className="btn btn-info btn-block"
          >
            Inserir
          </button>
        </Grid>
      </Grid>
    </form>
  );
};
export default CreateUser;
